define(["require", "exports", "knockout", "Currency", "Pages/Cart", "UI/Modal"], function (require, exports, ko, c, cart, m) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Context = void 0;
    var AddToCartTypeEnum;
    (function (AddToCartTypeEnum) {
        AddToCartTypeEnum["ADD_TO_CART"] = "AddToCart";
        AddToCartTypeEnum["ADD_TO_QUOTE"] = "AddToQuote";
        AddToCartTypeEnum["REQUEST_THIS_ITEM"] = "RequestThisItem";
    })(AddToCartTypeEnum || (AddToCartTypeEnum = {}));
    const PunchOutMeta = {
        countersketch: {
            atcText: "Tray"
        },
        matrixgold: {
            atcText: "Job"
        },
        everandever: {
            atcText: "Cart"
        }
    };
    class Context {
        constructor(data) {
            this.LoadCart = (callback) => {
                if (this.Cart() != null) {
                    callback();
                    return;
                }
                $.getJSON("/cart/getcart/").done(x => {
                    if (this.Cart() == null)
                        this.Cart(new cart.Cart(x.jsonCart));
                    callback();
                });
            };
            this.OpenUserTermsForReviewModal = (onCancel) => {
                if (this.OrderForReviewModal == null) {
                    this.OrderForReviewModal = new m.Modal({
                        ModalCssClass: "",
                        Title: "Order for Product Review/Conditional Sale",
                        BodyTemplates: [{
                                Name: "/pages/2870/?sectionOnly=true"
                            }],
                        FooterButtons: [{
                                Text: "I Agree",
                                CssClasses: "largeButton primary",
                                BootstrapCells: "col-sm-offset-9 col-sm-3",
                                Onclick: this.SaveUserTermsForReview
                            }]
                    });
                }
                this.OrderForReviewModal.OnHide(() => {
                    if (this.UserNeedsToAgreeToTermsForReview() && onCancel != null)
                        onCancel();
                });
                this.OrderForReviewModal.Open();
            };
            this.SaveUserTermsForReview = () => {
                this.UserNeedsToAgreeToTermsForReview(false);
                $.ajax({
                    url: "/myaccount/accountsettings/UserHasAgreedToOrderForReviewTerms/",
                    type: "POST",
                    dataType: "json"
                });
                if (this.OrderForReviewModal != null)
                    this.OrderForReviewModal.Close();
            };
            ko.mapping.fromJS(data, {
                Currency: {
                    create: opts => ko.observable(new c.Currency(Object.assign(Object.assign({}, opts.data), { Locale: data.CurrentCultureName })))
                }
            }, this);
            this.IsUSD = ko.pureComputed(() => this.Currency().Currency() == 'USD');
            this.GoogleMapApiKey = "AIzaSyDV9KSt6G6XywbGPuYs4iu4laQPYUfkm3c";
            this.Sequence = ko.observable(1);
            this.RequestId = createGuid();
            this.StullerFirstTrialData = ko.observable(null);
            this.Cart = ko.observable(null);
            this.CanPromoteStullerFirst = ko.computed(() => {
                if (!data.CanPromoteStullerFirst || this.HasScheduledOrder())
                    return false;
                if (this.Cart() == null)
                    return true;
                return ko.utils.arrayFirst(this.Cart().CartItems(), c => c.IsHazardous() || c.IsHeavy() || c.IsSingleShipmentItem()) == null;
            });
            this.IsInStullerFirstTrial.subscribe(value => {
                $.post("/cart/UpdateShippingWithStullerFirstTrialPromoToggle/", { optIntoStullerFirst: value }, data => {
                    this.StullerFirstTrialData(data);
                }, "json");
            });
            this.IframeHostApiDomain = ko.computed(() => {
                var parentDomain = null;
                if (this.AllowIframeHostApi() && window.sessionStorage) {
                    parentDomain = window.sessionStorage.getItem("IframeHostDomain");
                    if (!parentDomain) {
                        var match = document.referrer.match(/^https?:\/\/[^\/]+/i);
                        if (match) {
                            parentDomain = match[0];
                            window.sessionStorage.setItem("IframeHostDomain", parentDomain);
                        }
                    }
                    if (!(parentDomain && this.AllowIframeHostApiDomainsCsvList() && (this.AllowIframeHostApiDomainsCsvList().split(',').indexOf(parentDomain) !== -1 || this.AllowIframeHostApiDomainsCsvList() == '*'))) {
                        parentDomain = null;
                        window.sessionStorage.removeItem("IframeHostDomain");
                    }
                }
                return parentDomain;
            });
            this.IsUsingIframeHostApi = ko.computed(() => {
                return (this.AllowIframeHostApi() && this.IframeHostApiDomain() != null);
            });
            this.ShowcaseDisplaySettingsFullySetUp = ko.computed(() => {
                return !isNullOrEmpty(this.ShowcaseTitle())
                    && !isNullOrEmpty(this.ShowcasePhoneNumber())
                    && !isNullOrEmpty(this.ShowcaseEmailAddress());
            }, this);
            this.CartCount = ko.computed(() => {
                return this.Cart() == null ? data.CartCount : this.Cart().CartCount();
            }, this);
            this.IsConsultantModeTradeShowOrder = ko.computed(() => {
                if (!this.IsInConsultantMode())
                    return false;
                var consultantModeCookie = readCookie("ConsultantMode");
                return consultantModeCookie != null && consultantModeCookie.indexOf("Show Order") > 0;
            });
            this.AddToCartType = ko.computed(() => {
                if (this.IsInJewelerShowcase() && !this.HideAddToCart() && !(this.AllowIframeHostApi() && this.IsUsingIframeHostApi())) {
                    if (this.AddToQuote() == null) {
                        return AddToCartTypeEnum.REQUEST_THIS_ITEM;
                    }
                    return AddToCartTypeEnum.ADD_TO_QUOTE;
                }
                return AddToCartTypeEnum.ADD_TO_CART;
            });
            this.ShouldShowRequestThisItem = ko.computed(() => {
                return this.AddToCartType() === AddToCartTypeEnum.REQUEST_THIS_ITEM;
            });
            this.AddToCartText = (action) => {
                var _a;
                if (this.ShouldShowRequestThisItem()) {
                    return "Request this Item";
                }
                action = action || "Add to";
                let target = "Cart";
                const theme = this.PunchOutTheme();
                if (theme !== '' && ((_a = PunchOutMeta[theme]) === null || _a === void 0 ? void 0 : _a.atcText)) {
                    return `${action} ${PunchOutMeta[theme].atcText}`;
                }
                if (this.IsInJewelerShowcase() && this.IsUsingIframeHostApi() && this.IframeHostAPIButtonText()) {
                    return `${this.IframeHostAPIButtonText()}`;
                }
                return `${action} ${target}`;
            };
            this.IsLoggedIn = ko.pureComputed(() => this.LoginId() !== null || this.IsInJewelerShowcase());
            this.LoginUrl = ko.pureComputed(() => this.GetLoginUrl(window.location));
        }
        GetLoginUrl(location) {
            return '/login/?returnUrl=' + encodeURIComponent(location.pathname + location.search);
        }
    }
    exports.Context = Context;
    var currentContext;
    exports.default = currentContext;
});
//# sourceMappingURL=Context.js.map